export default function hydrateTickets({ stores, dispatch }: CommandArgs) {
  const bookingFlowStore: BookingFlowStore = stores['program/booking-flow']

  /**
   * Pre-selects the default ticket when the ticket picker is hidden.
   * Must run before any availability fetch so ticket quantities are included
   * in the availability request from the start.
   */
  function hydrateFromConfig() {
    dispatch('tickets:preselectRequiredTickets')

    if (!bookingFlowStore.showTicketSection) {
      dispatch('tickets:preselectDefaultTicket')
    }

    // Seeded ahead of the initial fetch, so the fetch scope has to follow it now.
    dispatch('availability:settleTicketQuantities')
  }

  return { hydrateFromConfig }
}

declare global {
  export type HydrateTicketsCommands = ReturnType<typeof hydrateTickets>

  interface CommandRegistry {
    'hydrate/tickets': HydrateTicketsCommands
  }
}
